import type { ReactNode } from "react";

import { SectionCard } from "@/components/ui/section-card";
import { cn } from "@/lib/utils";

interface ChartCardProps {
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  /** Altura util do canvas em px (default 280). */
  height?: number;
  /** Estado de loading -- mostra skeleton pulsante. */
  loading?: boolean;
  /** Mensagem para quando ``data`` esta vazio. */
  emptyMessage?: ReactNode;
  isEmpty?: boolean;
  children: ReactNode;
  className?: string;
}

/**
 * Wrapper de ``SectionCard`` especializado para gráficos. Reserva altura
 * fixa pro canvas (recharts precisa de pai com height definido) e
 * uniformiza skeletons e mensagens de vazio.
 */
export function ChartCard({
  title,
  description,
  actions,
  height = 280,
  loading = false,
  emptyMessage,
  isEmpty = false,
  children,
  className,
}: ChartCardProps) {
  return (
    <SectionCard
      title={title}
      description={description}
      actions={actions}
      className={cn("gap-4", className)}
    >
      <div className="relative w-full" style={{ height }}>
        {loading ? (
          <div className="h-full w-full animate-pulse rounded-xl bg-ink-100/40" />
        ) : isEmpty ? (
          <div className="flex h-full w-full items-center justify-center text-sm text-ink-500">
            {emptyMessage ?? "—"}
          </div>
        ) : (
          children
        )}
      </div>
    </SectionCard>
  );
}
